module.exports = __webpack_public_path__ + "media/images/icons/share-0f24620a350251c52da900607fbdacab.svg";